<template>
<div>
   <div class="loading" v-if="loading">
   
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch">
   <h2 class="ltext-105 pt-4 txt-center">
			Our Store
	</h2>
<section class="section-sm" style="padding-top:30px;">
	<div class="container">
		<!-- <div class="row">
			<div class="col-sm-12 py-3">
				<div class="search-result bg-gray text-center">
					<h2 class="mb-0 m-size text-info">Store Offers</h2>
         
				</div>
			</div>
		</div> -->
		<div class="row">
	
			<div class="col-sm-12 pt-2">
				
				<div class="product-grid-list">
					<div class="row mt-25 justify-content-around" >
            <div v-if="noresults">No Items are Available</div>
              <template v-for=" (offer, i) in offers" >
						<div class=" col-12 col-sm-6 col-md-4 col-lg-4 " v-bind:key="offer.id">
							<!-- product card -->
                        <div class="product-item bg-light">
	                        <div class="card">

                                 <div class="block2-pic hov-img0">
						    	<img :src="offer.image" alt="IMG-SHOP" >
								
						</div>
		<div class="card-body">
   
		    <h4 class="card-title"><a class="text-primary">{{offer.name}}</a></h4>
		     <ul class="list-inline product-meta mb-1 mt-2">
            <li class="list-inline-item mr-2">
		    		<a class="">{{offer.price}}</a>
		    	</li>
		    </ul>
        
		</div>
	</div>
</div>



						</div>
            </template>
						
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

  </div>
  </div>
</template>
<script>
import db from "../../config/FirebaseInit"
import firebase from "firebase/app"

export default {
  name: 'items',
   data() {
      return {
          loading: false,
          fetch: false,
          noresults: false,
          offers:[],
      };
    },
    methods:{
		 backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },
	},
    created(){
    console.log('this.route', this.$route)
      console.log('this.loading', this.loading)
     this.backToTop()
      this.loading = true
      this.fetch = false
      console.log('this.loading', this.loading)
    
      if(this.$store.state.starterplanproducts.length != 0){
        this.offers = this.$store.state.starterplanproducts
         this.loading = false
         this.fetch = true 
        console.log('items from store', this.$store.state.starterplanproducts)
      }else if(this.$store.state.starterplanproducts.length == 0){
      db.collection('products')
      .limit(50).get().then(querySnapshot => {
        this.offers = []
      querySnapshot.forEach(doc => {
        const data = {
          'id' : doc.id,
          'image': doc.data().img,
          'name': doc.data().name,
          'price': doc.data().price,
          'type': doc.data().type,
        }
        this.offers.push(data)
        this.$store.state.starterplanproducts = this.offers
        console.log(this.offers)
      })
      this.loading = false
      this.fetch = true 
      if(querySnapshot.docs.length == 0){
				  this.noresults = true
  					console.log("noresults", this.noresults);
	     }
      
    })
   }
     
    },
    mounted() {
   
  }
}
</script>
<style scoped>
   @import url('~@/assets/main/css/styles.css');
    @import url('~@/assets/main/css/loading.css');

.block2-pic{
  position: relative;
}
  .hov-img0 {
  display: block;
  overflow: hidden;
}

.hov-img0 img{
  width: 100%;
  -webkit-transition: transform 0.9s ease;
  -o-transition: transform 0.9s ease;
  -moz-transition: transform 0.9s ease;
  transition: transform 0.9s ease;
}

.hov-img0:hover img {
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -ms-transform: scale(1.1);
  -o-transform: scale(1.1);
  transform: scale(1.1);
}
 
  .product-meta li a i {
    color: #7C7ADA;
    font-size: 14px;
  }
  .product-meta li a {
    color:  #4A4AEC;
  }
  .product-meta li a :hover {
    color: #7C7ADA;
  }
  .fa {
    color: #7C7ADA;
    font-size: 15px;
}

.flex-c-m {
	justify-content: center;
	-ms-align-items: center;
	align-items: center;
}
.flex-w {
	-webkit-flex-wrap: wrap;
	-moz-flex-wrap: wrap;
	-ms-flex-wrap: wrap;
	-o-flex-wrap: wrap;
	flex-wrap: wrap;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
}
.w-full {width: 100%;}
.bg2 {background-color: #717fe0;}

.size-103 {
  min-width: 129px;
  height: 46px;
  cursor: pointer;
}	
.cl5 {color: #fff;}
.stext-101 {
  font-size: 15px;
  line-height: 1.466667;
  text-transform: uppercase;
}

@media (max-width: 575px){
  .category-search-filter {
    padding-bottom: 8px;
    margin-bottom: 25px;
  }
  .search-result{
    margin-top: 12px;
  }
 
}

@media (max-width: 767px){
	  h2 {
		  font-size: 30px;
		  padding-top: 4.2rem !important;
	  }
  }
</style>



// WEBPACK FOOTER //
// src/components/store/Items.vue